import { render, staticRenderFns } from "./cost-model.vue?vue&type=template&id=01045acd&scoped=true&"
import script from "./cost-model.vue?vue&type=script&lang=ts&"
export * from "./cost-model.vue?vue&type=script&lang=ts&"
import style0 from "./cost-model.vue?vue&type=style&index=0&id=01045acd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01045acd",
  null
  
)

export default component.exports